import React from 'react';
import { Building2, BrickWall, Hammer, Droplets } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../mockData';

const iconMap = {
  Building2: Building2,
  BrickWall: BrickWall,
  Hammer: Hammer,
  Droplets: Droplets,
};

const Services = () => {
  return (
    <section id="services" className="py-12 md:py-16 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-10 md:mb-12">
          <div className="flex items-center mb-4">
            <div className="w-16 h-0.5 bg-[#cab28e] mr-4" />
            <span className="text-[#cab28e] text-sm tracking-widest font-semibold md:tracking-[0.25em]">
              NAŠE USLUGE
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            NAŠA <span className="text-[#cab28e]">STRUČNOST</span>
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="bg-zinc-900/60 border-gray-800 md:rounded-xl hover:border-[#cab28e]/50 transition-all duration-300 group md:hover:-translate-y-1.5 md:hover:shadow-[0_16px_40px_rgba(0,0,0,0.7),0_0_24px_rgba(202,178,142,0.12)]"
              >
                <CardContent className="p-8">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-[#cab28e]/10 rounded-lg md:rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#cab28e]/20 transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-[#cab28e] md:group-hover:scale-110 transition-transform duration-300" />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-4 tracking-wide">
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-400 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
